import type { SVGComponentProps } from 'BreetHelpers';

export const ExportIcon = ({ ...props }: SVGComponentProps) => (
	<svg
		width='15'
		height='16'
		viewBox='0 0 15 16'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...props}
	>
		<path
			d='M7.49984 1.8418C4.16529 1.8418 1.45898 4.5481 1.45898 7.88265C1.45898 11.2172 4.16529 13.9235 7.49984 13.9235C10.8344 13.9235 13.5407 11.2172 13.5407 7.88265C13.5407 4.5481 10.8344 1.8418 7.49984 1.8418ZM10.6713 8.082C10.6713 8.32967 10.4659 8.53506 10.2182 8.53506C9.97055 8.53506 9.76516 8.32967 9.76516 8.082V6.25766L5.10162 10.9212C5.01101 11.0118 4.89623 11.0541 4.78145 11.0541C4.66668 11.0541 4.5519 11.0118 4.46129 10.9212C4.2861 10.746 4.2861 10.4561 4.46129 10.2809L9.12483 5.61733H7.30049C7.05281 5.61733 6.84742 5.41194 6.84742 5.16427C6.84742 4.91659 7.05281 4.7112 7.30049 4.7112H10.2182C10.4659 4.7112 10.6713 4.91659 10.6713 5.16427V8.082Z'
			fill='#022745'
		/>
	</svg>
);
